import type {IRecipient} from '@/api/types/recipient';
import {ERecipientType, ETimezones} from '@/api/enums/recipient';

export const recipientDefault: IRecipient = {
  id: '',

  name: '',
  username: null,
  type: ERecipientType.MANUAL,
  is_enabled: true,
  emails: [],
  telegrams: [],
  timezone: ETimezones['Etc/GMT-3'],

  tech_roles: [],
  view_roles: [],
  view_roles_map: [],
};
